import ResolvedFileItem from '../ResolvedFileItem';
import FileAttachmentWithProgress from '../FileAttachmentWithProgress';
import { List } from 'foundations-components/transitional/components/List';
import { jsx as _jsx } from "react/jsx-runtime";
const FileDraftsListItem = ({
  file,
  progress,
  fileReference
}) => {
  if (fileReference) {
    return /*#__PURE__*/_jsx(ResolvedFileItem, {
      fileReference: fileReference
    });
  }
  return /*#__PURE__*/_jsx(FileAttachmentWithProgress, {
    fileName: file.name,
    progress: progress
  });
};
const FileDraftsList = ({
  fileDraftsMap
}) => {
  return /*#__PURE__*/_jsx(List, {
    children: Array.from(fileDraftsMap.entries()).map(([file, {
      progress,
      fileReference
    }]) => {
      return /*#__PURE__*/_jsx(FileDraftsListItem, {
        file: file,
        progress: progress,
        fileReference: fileReference
      }, file.name);
    })
  });
};
export default FileDraftsList;